const VERSION = '3.12.5';
export default VERSION;
